import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  const heroImgRef = useRef<HTMLImageElement>(null);
  const [heroLoaded, setHeroLoaded] = useState(false);

  useEffect(() => {
    if (heroImgRef.current?.complete) {
      setHeroLoaded(true);
    }
  }, []);

  const featuredArticle = articles.find((a) => a.isHot) || articles[0];
  const latestArticles = articles.slice(0, 8);
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 5);

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="黑料网不打烊 - 24小时持续更新独家黑料"
        description="黑料网不打烊，全天候24小时不间断更新最新独家黑料内容，汇聚娱乐圈、网红、明星最劲爆料，随时随地畅享海量黑料资讯，从不停歇，永不打烊。"
        keywords="黑料网不打烊,黑料网24小时,黑料不打烊最新,独家黑料更新,娱乐圈黑料,网红黑料爆料,明星黑料资讯"
        canonicalUrl="https://heiliao-budayang.com/"
        ogTitle="黑料网不打烊 - 24小时持续更新独家黑料"
        ogDescription="全天候24小时不间断更新最新独家黑料内容，汇聚娱乐圈、网红、明星最劲爆料。"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '黑料网不打烊',
            url: 'https://heiliao-budayang.com/',
            description: '全天候24小时不间断更新最新独家黑料内容，汇聚娱乐圈、网红、明星最劲爆料。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://heiliao-budayang.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '黑料网不打烊',
            url: 'https://heiliao-budayang.com/',
            description: '24小时不间断更新的娱乐八卦资讯平台',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'contact@heiliao-budayang.com',
              contactType: 'customer service',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '黑料网不打烊 - 首页',
            url: 'https://heiliao-budayang.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '黑料网不打烊',
              url: 'https://heiliao-budayang.com/',
            },
          }),
        }}
      />

      <Navbar />

      <main>
        <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
          <img
            ref={heroImgRef}
            src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20city%20nightscape%20with%20glowing%20red%20and%20amber%20neon%20signs%2C%20mysterious%20urban%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20foggy%20streets%2C%20an%20artistic%20interpretation%20of%20a%20bustling%20entertainment%20district%20at%20night%2C%20vibrant%20yet%20dark%20mood%2C%20no%20text%20no%20people%20visible&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="黑料网不打烊 - 24小时娱乐八卦资讯"
            title="黑料网不打烊 - 24小时持续更新独家黑料"
            onLoad={() => setHeroLoaded(true)}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${heroLoaded ? 'opacity-100' : 'opacity-0'}`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <div className={`transition-all duration-700 ${heroLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-500/30 text-accent-300 text-sm mb-6">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-400"></span>
                </span>
                24小时不打烊 · 持续更新中
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading mb-4 leading-tight">
                黑料网不打烊
              </h1>
              <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
                全天候24小时不间断更新最新独家黑料内容，汇聚<strong>娱乐圈</strong>、<strong>网红</strong>、<strong>明星</strong>最劲爆料，随时随地畅享海量黑料资讯
              </p>
              <div className="flex flex-wrap items-center justify-center gap-3">
                <Link
                  to={`/article/${featuredArticle.slug}`}
                  className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看今日头条
                </Link>
                <a
                  href="#latest"
                  className="px-6 py-3 rounded-full bg-background-50/10 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/20 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
                >
                  浏览最新爆料
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                <a href="#hot-articles">🔥 热门爆料</a>
              </h2>
              <Link to="/category/yulequan" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer">
                查看更多 <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
              {hotArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-2 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2">
                <ArticleCard article={featuredArticle} variant="featured" />
              </div>
              <div className="flex flex-col gap-4">
                {articles.slice(1, 4).map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section id="latest" className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                <a href="#latest-articles">📰 最新更新</a>
              </h2>
              <Link to="/category/yulequan" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer">
                查看全部 <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-6">
              <a href="#categories">📂 内容分类</a>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-3 p-6 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-200/50 hover:bg-background-50 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900 whitespace-nowrap">{cat.name}</span>
                  <span className="text-xs text-foreground-400 text-center leading-relaxed hidden sm:block">{cat.description}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="col-span-2">
                <div className="flex items-center gap-2 mb-6">
                  <div className="w-6 h-6 flex items-center justify-center text-primary-600">
                    <i className="ri-flashlight-line text-lg"></i>
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                    <a href="#latest-list">最新文章列表</a>
                  </h2>
                </div>
                <div className="flex flex-col gap-1">
                  {articles.slice(5, 14).map((article, idx) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className="group flex items-center gap-3 py-3 px-3 rounded-lg hover:bg-background-50 transition-colors cursor-pointer border-b border-background-200/40 last:border-0"
                    >
                      <span className="text-xs font-mono text-foreground-300 w-5 flex-shrink-0">
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                      <span className="flex-1 text-sm text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">
                        {new Date(article.publishedAt).toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' })}
                      </span>
                      {article.isHot && (
                        <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">热</span>
                      )}
                    </Link>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center gap-2 mb-6">
                  <div className="w-6 h-6 flex items-center justify-center text-accent-600">
                    <i className="ri-fire-line text-lg"></i>
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                    <a href="#trending">热门标签</a>
                  </h2>
                </div>
                <div className="flex flex-wrap gap-2">
                  {Array.from(new Set(articles.flatMap((a) => a.tags))).slice(0, 20).map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1.5 rounded-full bg-background-50 text-sm text-foreground-600 border border-background-200/60 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}